import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class PlaceService {

    static getPlace(item) {

        let api = `${API_BASE_URL}${API_PATHS.getPlace}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
       
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api,item);
    }

    static addPlace(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addPlace}`;
        return axiosInstance
            .post(api, data)

    }

    static editPlace(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editPlace}`;
        return axiosInstance
            .put(api, data)

    }

    static deletePlace(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deletePlace}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default PlaceService;
